import React from "react";
import {ChartsContainerPro} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCChartContainer extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["DisableAxisListener", "disableAxisListener"],
        ["Height", "height"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["InitialZoom", "initialZoom"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onHighlightChange", "onHighlightChange"],
        ["onZoomChange", "onZoomChange"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Width", "width"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <ChartsContainerPro {...chartProps}>{this.props.children}</ChartsContainerPro>;
    }
}

export default CCChartContainer;
